import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	background: ${({ theme }) => theme.white};
	border: 1px solid ${({ theme }) => theme.grayDark};
	border-radius: 8px;
	width: 100%;
`;
export const HeaderCard = styled.div`
	border-bottom: 1px solid ${({ theme }) => theme.grayDark};
	width: 100%;
	display: flex;
	justify-content: space-between;
`;

export const HeaderTitle = styled.div`
	text-align: left;
`;

export const HeaderWarning = styled.div`
	text-align: right;
	margin: 0.4rem 0.8rem;
	display: flex;
	align-items: center;
`;

export const BodyCard = styled.div`
	width: 100%;
`;
